import { render, staticRenderFns } from "./BaseInputConfirmChange.vue?vue&type=template&id=64cd8178&scoped=true&lang=pug&"
import script from "./BaseInputConfirmChange.vue?vue&type=script&lang=js&"
export * from "./BaseInputConfirmChange.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputConfirmChange.vue?vue&type=style&index=0&id=64cd8178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd8178",
  null
  
)

export default component.exports